import type { GetApiIntroducerPortalIntroducerApplicationDocumentFeedbackResponse } from '@iwoca/lapi-client/introducer_portal';
import { isAdditionalInfoRequestRenderable } from './AdditionalInfoGroup/AdditionalInfoGroup.helper';

export function getDocumentsFeedbackStats(
  documentFeedback:
    | GetApiIntroducerPortalIntroducerApplicationDocumentFeedbackResponse
    | undefined,
): {
  feedbackShown: boolean;
  feedbackItemCount: number;
  feedbackItemsResolved: number;
} {
  if (!documentFeedback) {
    return {
      feedbackShown: false,
      feedbackItemCount: 0,
      feedbackItemsResolved: 0,
    };
  }

  const reviews = documentFeedback.data.doc_requirement_reviews ?? [];
  const additionalInfoRequests = (
    documentFeedback.data.additional_info_requests ?? []
  ).filter((request) =>
    isAdditionalInfoRequestRenderable(request.request_type),
  );

  const feedbackItemCount = reviews.length + additionalInfoRequests.length;
  const feedbackShown = feedbackItemCount > 0;

  if (!feedbackShown) {
    return {
      feedbackShown: false,
      feedbackItemCount: 0,
      feedbackItemsResolved: 0,
    };
  }

  const feedbackItemsResolved =
    reviews.filter((review) => review.marked_as_done).length +
    additionalInfoRequests.filter((request) => request.marked_as_done).length;

  return { feedbackShown, feedbackItemCount, feedbackItemsResolved };
}
